export const NETWORKTEAM_ADDIX = "NetworkteamAddix";
export const NETWORKTEAM_UNITED_DOMAINS = "NetworkteamUnitedDomains";
export const CUSTOMER = "Customer";
